import React, { useState } from "react";
import { LoginStyled } from "./login.styled";

const Login: React.FC<{
  handleLogin: () => void;
  name: string;
  setName: (name: string) => void;
  phoneNumber: string;
  setPhoneNumber: (password: string) => void;
}> = ({ handleLogin, name, setName, phoneNumber, setPhoneNumber }) => {
  return (
    <LoginStyled>
    <div className="full-screen row">
      <div className=" centered-text image-logo-sec col-6">
      </div>
      <div className=" centered-text col-6">
        <h3>Login</h3>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleLogin();
          }}
        >
          {/* <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div> */}
          <div className="form-group">
            <label>Phone Number / User ID</label>
            <input
              type="number"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
          </div>
          <button type="submit">Login</button>
        </form>
      </div>
    </div>
    </LoginStyled>
  );
};

export default Login;
